import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import useResizeListener from '../../hooks/useResizeListener';
import Event from '../../lib/EventEmitter';
import { getPageTitle } from '../../lib/BrowserServerCommon/BrowserServerCommon';
import { Composition } from '../../types/api/Composition';

export const useGenericPage = (composition: Composition) => {
  const windowInnerWidth = useResizeListener();
  const location = useLocation();

  const updateDocumentTitle = () => {
    const { headMetaInfo, editModeInfo } = composition;
    global.document.title = getPageTitle({ headMetaInfo, editModeInfo, searchQuery: location.search });
  };

  useEffect(() => {
    updateDocumentTitle();
  }); // always call this to keep title upToDate

  // call this once on mount, to indicate when JS has finished loading
  useEffect(() => {
    Event.emit(Event.loadingFeedback.stop);
    // we need special attribute for cypress test
    global.document.documentElement.setAttribute('data-react-loaded', '');
  }, []);

  const [accessKeysEnabled, setAccessKeysEnabled] = useState(
    composition.userInfo && composition.userInfo.settings && composition.userInfo.settings.accessKeysEnabled
      ? composition.userInfo.settings.accessKeysEnabled
      : false
  );

  const resetAccessKeys = useCallback(
    () => setAccessKeysEnabled(composition?.userInfo?.settings?.accessKeysEnabled || false),
    [composition?.userInfo?.settings?.accessKeysEnabled]
  );
  const disableAccessKeys = useCallback(() => setAccessKeysEnabled(false), []);
  const enableAccessKeys = useCallback(() => setAccessKeysEnabled(true), []);

  return {
    windowInnerWidth,
    accessKeysEnabled,
    resetAccessKeys,
    disableAccessKeys,
    enableAccessKeys,
  };
};
